import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardFooter, CardHeader } from '../../../../components/card/card';
import Select from 'react-select';

import {
  cleanElementEntryToAddList,
  GetElementEntryToAdd,
  InsertPayElementEntry
} from '../../../../store/HR/Payroll/payrollElementEntrySlice';
import { AddPayrollElementEntrySchema } from '../../../ValidationForm/validationSchema';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import useGetPeriodTimeByPayroll from '@hooks/Payrolls/useGetPeriodTimeByPayroll';
import List from './List';

function AddElementEntry() {
  const { assignmentId, payrollId } = useParams();
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { optionPeriodTime } = useGetPeriodTimeByPayroll(payrollId, assignmentId);
  const [period, setPeriod] = useState(null);

  useEffect(() => {
    if (!period && optionPeriodTime?.length > 0) {
      const defaultOption = optionPeriodTime[0];
      if (defaultOption) {
        setPeriod(defaultOption);
      }
    }
  }, [optionPeriodTime, period]);

  useEffect(() => {
    if (period) {
      dispatch(
        GetElementEntryToAdd({
          periodId: period.value,
          assignmentId: assignmentId
        })
      );
    }

    return () => {
      dispatch(cleanElementEntryToAddList());
    };
  }, [dispatch, assignmentId, period]);

  const { ElementEntryToAddList: data, loading } = useSelector(state => state.PayElementEntry);

  const formik = useFormik({
    initialValues: {
      assignmentId: assignmentId,
      startDate: '',
      endDate: '',
      elementLinkId: '',
      elementTypeId: '',
      screenEntryValue: '',
      isRecurring: null, // Only for handle hide and show and validation  based on  isRecurring
      TypeUom: null // Only for handle with change Type Elemnent based on Uom
    },
    validationSchema: AddPayrollElementEntrySchema(t),

    onSubmit: values => {
      dispatch(
        InsertPayElementEntry({
          assignmentId: assignmentId,
          startDate: values.startDate,
          endDate: values.isRecurring === false ? values.endDate : null,
          elementLinkId: values.elementLinkId,
          elementTypeId: values.elementTypeId,
          screenEntryValue: String(values.screenEntryValue)
        })
      )
        .unwrap()
        .then(res => {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          dispatch(
            GetElementEntryToAdd({
              periodId: period.value,
              assignmentId: assignmentId
            })
          );
        })
        .catch(error => {
          CustomAlert({ action: 'Error', msg: error });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  async function handleSelectChange(e) {
    const selectedOption = e.target.selectedOptions[0];

    // debugger
    const ElementLinkID = e.target.value;
    const selected_Uom_Type = selectedOption.dataset.uomType;
    const selected_isRecurring = selectedOption.dataset.isRecurring;
    const selected_elementTypeId = selectedOption.dataset.elementType;
    // console.log(selected_isRecurring);
    // console.log(selected_elementTypeId);

    formik.setFieldValue('elementLinkId', ElementLinkID);
    formik.setFieldValue('TypeUom', selected_Uom_Type);
    formik.setFieldValue('isRecurring', selected_isRecurring);
    formik.setFieldValue('elementTypeId', selected_elementTypeId);
  }
  //_______________
  //#region
  const location = useLocation();
  const [reference, setReference] = useState(null); // State to hold ReferenceName
  useEffect(() => {
    if (location.state && location.state.ReferenceName) {
      // const { ReferenceName } = location.state;
      if (location.state) {
        setReference(location.state); // Update ReferenceName state
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log(reference);

  //#endregion

  //____________________________

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },

            {
              name: t('PayrollElementEntry'),
              link: '/Pay/PayrollElementEntry'
            },
            {
              name: t('PayrollElementEntry'),
              link: null
            }
          ]}
          PageName={t('PayrollElementEntry')}
          // subtitle={referenceName}
        />

        <div className='ms-auto'>
          <button
            type='button'
            className=' btn me-1 btn-default mb-1'
            onClick={() => Navigate(-1, { replace: true })}
          >
            <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
          </button>
        </div>
      </div>

      <div className='row mb-3'>
        <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12 pb-2 '>
          <Card className='m-0 card-hover-effect h-100 border-theme'>
            <CardHeader className='fw-bold bg-theme bg-opacity-20 '>
              <i className='fa fa-user-tie text-theme me-2'></i> {t('الموظــف')}
            </CardHeader>
            <CardBody>
              <div className='d-flex justify-content-between fw-bold text-theme fs-5'>
                {reference?.ReferenceName}
              </div>
            </CardBody>
          </Card>
        </div>
        <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12 pb-2 '>
          <Card className='m-0 card-hover-effect h-100 border-theme'>
            <CardHeader className='fw-bold bg-theme bg-opacity-20 '>
              <i className='fa fa-money-bill-wave text-theme me-2'></i> {t('الراتــب')}
            </CardHeader>
            <CardBody>
              <div className='d-flex justify-content-between fw-bold text-theme fs-5'>
                {/* {i18n.language === 'en' ? data?.payrollName : data?.payrollName2} */}
                {reference?.PayrollName}
              </div>
            </CardBody>
          </Card>
        </div>
        <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12 pb-2 '>
          <Card className='m-0 card-hover-effect h-100 border-theme'>
            <CardHeader className='fw-bold bg-theme bg-opacity-20 '>
              <i className='fa fa-calendar-alt text-theme me-2'></i> {t('الفترة')}
            </CardHeader>
            <CardBody>
              <div className='d-flex justify-content-between'>
                <Select
                  classNamePrefix='react-select'
                  className='w-100  '
                  isSearchable
                  isClearable
                  options={optionPeriodTime}
                  onChange={option => setPeriod(option === null ? null : option)}
                  value={period}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                  formatOptionLabel={option => (
                    <div className='d-flex justify-content-between align-items-center'>
                      <div className='text-theme fw-bold'>{option.label}</div>
                      {option?.hasRun && ( // إذا كان hasRun = true، تظهر الشارة
                        <span className='badge bg-success ms-2'>
                          <i className='fas fa-check'></i> {/* أيقونة ✓ */}
                          {/* أو نص بدلاً من الأيقونة */}
                          {i18n.language === 'ar' ? 'تم تسيير الراتب' : 'Payroll Processed'}
                        </span>
                      )}
                    </div>
                  )}
                  // formatOptionLabel={option => (
                  //   <div className='d-flex justify-content-between align-items-center'>
                  //     <div className='text-theme fw-bold'>{option.label}</div>
                  //     {option.hasRun && (
                  //       <span className='badge bg-danger bg-opacity-75'>
                  //         {i18n.language === 'ar' ? 'تم التشغيل' : 'Processed'}
                  //       </span>
                  //     )}
                  //   </div>
                  // )}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      <Card className='mb-3'>
        <CardHeader>
          <i className='fa fa-clipboard-list text-theme me-2 fa-lg'></i>
          {t('الإدخـالات')}
        </CardHeader>
        <Loading loading={loading}>
          <CardBody>
            <Form onSubmit={formik.handleSubmit} hidden={false}>
              <div className='row'>
                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Elemente')}</label>
                    <Select
                      classNamePrefix='react-select'
                      className='w-100  '
                      isSearchable
                      isClearable
                      options={data?.elementLink?.map(item => ({
                        value: item.elementLinkId,
                        label:
                          i18n.language === 'en' ? item.elementTypeName : item.elementTypeName2,
                        isRecurring: item.isRecurring,
                        uom: item.uom,
                        elementTypeId: item.elementTypeId
                      }))}
                      onChange={option => {
                        formik.setFieldValue(
                          'elementLinkId',
                          option === null ? null : option.value
                        );
                        formik.setFieldValue('TypeUom', option === null ? null : option.uom);
                        formik.setFieldValue(
                          'isRecurring',
                          option === null ? null : option.isRecurring
                        );
                        formik.setFieldValue(
                          'elementTypeId',
                          option === null ? null : option.elementTypeId
                        );
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                      formatOptionLabel={option => (
                        <div className='d-flex flex-column'>
                          <div className=''>{option.label}</div>

                          <div className='d-flex  align-items-center mt-1'>
                            <span className='badge bg-info text-white me-2'>{option.uom}</span>
                            {option.isRecurring ? (
                              <span className='badge bg-success text-white'>دوري</span>
                            ) : (
                              <span className='badge bg-secondary text-white'>غير دوري</span>
                            )}
                          </div>
                        </div>
                      )}
                    />

                    {formik.errors.elementLinkId && (
                      <div className='text-danger small'>{formik.errors.elementLinkId}</div>
                    )}
                  </div>
                </div>

                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Value')}</label>
                    <Form.Control
                      className='form-control'
                      type={
                        formik.values.TypeUom === 'Text'
                          ? 'text'
                          : formik.values.TypeUom === 'Date'
                          ? 'date'
                          : formik.values.TypeUom === 'Money' || 'Day'
                          ? 'number'
                          : formik.values.TypeUom
                      }
                      name='screenEntryValue'
                      onChange={formik.handleChange}
                      value={formik.values.screenEntryValue}
                      isInvalid={formik.touched.screenEntryValue && formik.errors.screenEntryValue}
                    />
                    {formik.errors.screenEntryValue && (
                      <div className='text-danger small'>{formik.errors.screenEntryValue}</div>
                    )}
                  </div>
                </div>

                <div className={formik.values.isRecurring ? 'col-xl-4' : 'col-xl-2'}>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Start Date')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='startDate'
                      onChange={formik.handleChange}
                      value={formik.values.startDate}
                      isInvalid={!!(formik.touched.startDate && formik.errors.startDate)}
                    />
                    {formik.errors.startDate && (
                      <div className='text-danger small'>{formik.errors.startDate}</div>
                    )}
                  </div>
                </div>

                {!formik.values.isRecurring && (
                  <div className='col-xl-2'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Date_TO')}</label>
                      <Form.Control
                        disabled={formik.values.isRecurring}
                        className='form-control text-center'
                        type='date'
                        name='endDate'
                        onChange={formik.handleChange}
                        value={formik.values.endDate}
                        isInvalid={!!(formik.touched.endDate && formik.errors.endDate)}
                      />
                      {formik.errors.endDate && (
                        <div className='text-danger small'>{formik.errors.endDate}</div>
                      )}
                    </div>
                  </div>
                )}

                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>&nbsp;</label>

                    {period?.hasRun ? (
                      <>
                        <button
                          disabled={period?.hasRun}
                          type='reset'
                          className='btn btn-secondary w-100'
                        >
                          {t('لا يمكن الإضافة')}
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          disabled={formik.isSubmitting}
                          type='submit'
                          className='btn   btn-outline-theme w-100'
                        >
                          {formik.isSubmitting ? (
                            <div className='spinner-border spinner-border-sm me-2'></div>
                          ) : (
                            <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                          )}
                          {t('Add')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          </CardBody>

          <CardFooter>
            {data?.elemntEntry?.length > 0 && period && (
              <List list={data?.elemntEntry || []} period={period || null} />
            )}
          </CardFooter>
        </Loading>
      </Card>
    </>
  );
}

export default AddElementEntry;
